$(document).ready(function () {
    setTimeout(function () {
        // Find the second .variant-picker__option
        var secondVariantPickerOption = $('.variant-picker__option').eq(1);

        // Find the first label inside the second .variant-picker__option that does not have the .is-disabled class
        var firstAvailableVariant = secondVariantPickerOption.find('label').not('.is-disabled').first();

        // If such a label exists, perform a click on it
        if (firstAvailableVariant.length) {
            firstAvailableVariant.click();
        }
    }, 500); // 2000 milliseconds = 2 seconds
});












document.addEventListener('DOMContentLoaded', function () {
    fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(data => {
            const countryCode = data?.detected_values?.country?.handle; // Extract the country code
            console.log("You are coming from:", countryCode);

            const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

            $('p.prose.heading').each(function () {
                const text = $(this).text();

                // Handle FREE SHIPPING ABOVE text
                if (text === 'FREE SHIPPING ABOVE') {
                    if (countryCode === 'NL') {
                        $(this).text('FREE SHIPPING ABOVE €150');
                    } else if (countryCode === 'UK') {
                        $(this).text('FREE SHIPPING ABOVE £200');
                    } else if (countryCode === 'US') {
                        $(this).text('FREE SHIPPING ABOVE $200');
                    } else if (euCountries.includes(countryCode)) {
                        $(this).text('FREE SHIPPING ABOVE €200');
                    } else {
                        $(this).text('FREE SHIPPING ABOVE €200 / $150');
                    }
                }

                // Handle Fast delivery text
                if (text === 'Fast delivery') {
                    if (countryCode === 'NL') {
                        $(this).text('Fast delivery | Same day if ordered before 3pm');
                    } else if (euCountries.includes(countryCode)) {
                        $(this).text('Fast delivery | 2-5 days');
                    } else if (countryCode === 'US') {
                        $(this).text('Fast delivery | 5 days in US');
                    } else {
                        $(this).text('Fast delivery | Same day in NL*, 2-5 days in EU, 5 days in US');
                    }
                }
            });
        })
        .catch(error => {
            console.error('Error:', error);
            // Handle error if the request fails
        });
});


$(document).ready(function () {
    $('a[href="#signupform"]').on('click', function (event) {
        event.preventDefault(); // Prevent the default anchor click behavior
        $('html, body').animate({
            scrollTop: $('#shopify-section-sections--22675761660240__1708970804c701ff4e').offset().top
        }, 1000); // Adjust the scroll duration (1000 milliseconds = 1 second)
    });
});




/* Shipping text accordion tab on product pages*/

document.addEventListener('DOMContentLoaded', function () {
    fetch('/browsing_context_suggestions.json')
        .then(response => response.json())
        .then(data => {
            const countryCode = data?.detected_values?.country?.handle; // Extract the country code
            console.log("You are coming from:", countryCode);

            const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

            const updateText = () => {
                let freeShippingText = '';
                let deliveryTimesText = '';

                if (countryCode === 'NL') {
                    freeShippingText = 'Free Shipping on orders above €150';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 1 working day';
                } else if (countryCode === 'UK') {
                    freeShippingText = 'Free Shipping on orders above £200';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 2-4 working days';
                } else if (countryCode === 'US') {
                    freeShippingText = 'Free Shipping on orders above $300';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 5-7 working days';
                } else if (countryCode === 'DE' || countryCode === 'BE') {
                    freeShippingText = 'Free Shipping on orders above €200';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 1-2 working days';
                } else if (euCountries.includes(countryCode)) {
                    freeShippingText = 'Free Shipping on orders above €200';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 2-4 working days';
                } else {
                    freeShippingText = 'Free Shipping on orders above $300';
                    deliveryTimesText = '<strong>Delivery Time:</strong> 5-7 working days';
                }

                // Update the text of the elements
                $('.freeshippingtext').html(freeShippingText);
                $('.deliverytimes').html(deliveryTimesText);

            };

            updateText();
        })
        .catch(error => {
            console.error('Error:', error);
            // Handle error if the request fails
        });
});


$('a[aria-controls="cart-drawer"]').on('click', function () {
    setTimeout(function () {
        console.log("Reinitializing Flickity");
        var flkty = new Flickity('.product-slider', {
            // Options
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            wrapAround: false,
            prevNextButtons: true,
            pageDots: true
        });
        flkty.reloadCells()
        flkty.resize()
    }, 250);
});

// video autoplay pause event


document.addEventListener("DOMContentLoaded", function() {
 
  function updateVideoSettings() {
    const mobileVideo = document.querySelector('.mobile-video');
    const desktopVideo = document.querySelector('.desktop-video');
    if (window.innerWidth <= 768) { 
      if (mobileVideo) {
        mobileVideo.muted = false; 
        mobileVideo.play(); 
      }
      if (desktopVideo) {
        desktopVideo.muted = true; 
        desktopVideo.pause(); 
      }
    } else {
      if (desktopVideo) {
        desktopVideo.muted = false; 
        desktopVideo.play(); 
      }
      if (mobileVideo) {
        mobileVideo.muted = true;
        mobileVideo.pause(); 
      }
    }
  }
  updateVideoSettings();
  window.addEventListener('resize', updateVideoSettings);
});




document.addEventListener("click", function (e) {
  const link = e.target.closest('a[href="#nsignup"]');
  if (!link) return;

  e.preventDefault();

  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const formID = isMobile ? "S2ceeN" : "TLHRAe";

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(["openForm", formID]);
});
